import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLinkOpen20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLinkOpen20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.25 5.75a4.25 4.25 0 0 0 0 8.5h2a.75.75 0 0 0 0-1.5h-2a2.75 2.75 0 1 1 0-5.5h2a.75.75 0 0 0 0-1.5zm9.5 8.5a4.25 4.25 0 0 0 0-8.5h-2a.75.75 0 0 0 0 1.5h2a2.75 2.75 0 1 1 0 5.5h-2a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLinkOpen20);
